import { Grid, Paper } from "@mui/material"
import { Title } from "components/Common/Title"
import { DeviceList } from "components/Device/DeviceList"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import deviceService from "services/deviceService"
import organizationService from "services/organizationService"
import { setDevices } from "slices/deviceSlice"
import { setCurrentOrganization } from "slices/organizationSlice"

export function OrganizationDevices() {
  const { id } = useParams()
  const dispatch = useAppDispatch()

  const currentOrganization = useAppSelector((state) => state.organization.currentOrganization)

  const devices = useAppSelector((state) => state.device.devices)

  useEffect(() => {
    if (currentOrganization === undefined && id) {
      organizationService
        .getOrganization(id)
        .then((organization) => {
          dispatch(setCurrentOrganization(organization))
        })
        .catch((err) => {
          console.log(err)
        })
    }

    if (devices.length < 1 && id) {
      deviceService
        .getOrganizationDevices(id)
        .then((devices) => {
          dispatch(setDevices(devices))
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [currentOrganization, devices.length, dispatch, id])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Grid container paddingBottom={2}>
            <Grid item xs>
              <Title>DEVICES</Title>
            </Grid>
            <Grid item></Grid>
          </Grid>
          <DeviceList />
        </Paper>
      </Grid>
    </Grid>
  )
}
